import { Button, Container, Link, Stack, Typography } from "@mui/material";
import MayDay from "assets/error-page.svg?react";
import { SUPPORT_EMAIL } from "codes";

export interface ErrorPageProps {
  /**Window goBack */
  goBack: () => void;
  /**Window push */
  push?: (path: string) => void;
  address: string;
  homePath?: string;
}

const ErrorPage = ({
  goBack,
  push,
  homePath = "/dashboard",
  address = SUPPORT_EMAIL,
}: ErrorPageProps) => {
  const handleTryAgainClick = () => {
    goBack();
  };

  const mailto = `mailto:${address}?subject=${encodeURIComponent(
    "Error encountered",
  )}&body=${encodeURIComponent(
    "I encountered an error. Please include the support reference shown on the page.",
  )}`;

  return (
    <Stack justifyContent="center" alignItems="center" spacing={3}>
      <Container maxWidth="sm">
        <MayDay />
      </Container>
      <Typography variant="h3" textAlign="center">
        Oops! Something went wrong.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={handleTryAgainClick}>
          Try Again
        </Button>
        <Button
          variant="outlined"
          onClick={() =>
            push ? push(homePath) : window.location.assign(homePath)
          }
        >
          Go Home
        </Button>
        <Button component={Link} href={mailto}>
          Contact Us
        </Button>
      </Stack>
    </Stack>
  );
};

export default ErrorPage;
